"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slotExists = slotExists;
const array_1 = require("../array");
const getSlotValue_1 = require("./getSlotValue");
/**
 * Will check the provided slot map with the array of potential slot names to see if there is a value.
 *
 * @param slots
 * @param slotNames
 */
function slotExists(slots, slotNames) {
    let hasSlot = false;
    if (!slots || !(0, array_1.existsAndNotEmpty)(slotNames)) {
        return hasSlot;
    }
    for (const slotName of slotNames) {
        if ((0, getSlotValue_1.getSlotValue)(slots, slotName)) {
            hasSlot = true;
            break;
        }
    }
    return hasSlot;
}
//# sourceMappingURL=slotExists.js.map